import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import './DeleteConfirmModal.css';

interface DeleteConfirmModalProps {
  organizationName: string;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  isDeleting: boolean;
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  organizationName,
  onClose,
  onConfirm,
  isDeleting,
}) => {
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget && !isDeleting) {
      onClose();
    }
  };

  const handleConfirm = async () => {
    await onConfirm();
  };

  return (
    <div className="delete-confirm-modal-backdrop" onClick={handleBackdropClick}>
      <div className="delete-confirm-modal">
        <div className="delete-confirm-modal-header">
          <div className="delete-confirm-modal-icon">
            <AlertTriangle size={24} />
          </div>
          <button
            className="delete-confirm-modal-close"
            onClick={onClose}
            disabled={isDeleting}
            aria-label="Close modal"
          >
            <X size={20} />
          </button>
        </div>

        <div className="delete-confirm-modal-body">
          <h2>Delete Organization</h2>
          <p>
            Are you sure you want to delete <strong>"{organizationName}"</strong>?
          </p>
          <p className="delete-confirm-modal-warning">
            This action cannot be undone. All user associations with this organization will be removed.
          </p>
        </div>

        <div className="delete-confirm-modal-footer">
          <button
            type="button"
            className="delete-confirm-modal-btn cancel"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="delete-confirm-modal-btn delete"
            onClick={handleConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete Organization'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
